import { Controller } from "@hotwired/stimulus"
import { clamp, triangleArea } from "../lib/geometry"

export default class extends Controller {
  static targets = ["apex", "altitude", "area", "polygon", "slider", "svg"]

  connect() {
    this.move = this.move.bind(this)
    this.stop = this.stop.bind(this)
    this.update()
  }

  update() {
    const x = Number(this.sliderTarget.value)
    this.polygonTarget.setAttribute("points", `140,280 ${x},100 460,280`)
    this.apexTarget.setAttribute("cx", x)
    this.altitudeTarget.setAttribute("x1", x)
    this.altitudeTarget.setAttribute("x2", x)
    this.areaTarget.textContent = triangleArea(32, 18)
  }

  start(event) {
    event.preventDefault()
    window.addEventListener("pointermove", this.move)
    window.addEventListener("pointerup", this.stop, { once: true })
  }

  move(event) {
    const box = this.svgTarget.getBoundingClientRect()
    this.sliderTarget.value = clamp(((event.clientX - box.left) / box.width) * 600, 90, 510)
    this.update()
  }

  stop() {
    window.removeEventListener("pointermove", this.move)
  }

  disconnect() {
    this.stop()
  }
}
